import { render } from "./ContentArea.vue?vue&type=template&id=37c4a25e&scoped=true"
import script from "./ContentArea.vue?vue&type=script&lang=js"
export * from "./ContentArea.vue?vue&type=script&lang=js"

import "./ContentArea.vue?vue&type=style&index=0&id=37c4a25e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c4a25e"]])

export default __exports__